import {ColDef} from 'ag-grid-community';
import {CellType} from '@esgi/ui/ag-grid';

export function isNumericColumn(colDef: ColDef) {
	return (
		(typeof colDef.type === 'string' && colDef.type === CellType.Numeric) ||
		(Array.isArray(colDef.type) && colDef.type.includes(CellType.Numeric))
	);
}
